import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const downloadPossFile = (filters = {}) => apiActionCreator({
  'endpoint': '/orders/dealers/poss',
  'authenticated': true,
  'types': [
    ActionTypes.DOWNLOAD_POSS_FILE_REQUEST,
    ActionTypes.DOWNLOAD_POSS_FILE_SUCCESS,
    [
      ActionTypes.DOWNLOAD_POSS_FILE_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'POST',
  'contentType': 'application/json',
  'data': filters,
});
